import React from 'react';

const SvgButtonLoader = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  style: {
    margin: 'auto'
  },
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  display: "block"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "ButtonLoader_svg__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(74 50)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 2,
  transform: "scale(3.02974)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.875s",
  values: "3.26 3.26;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.875s"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(45 -47.355 114.325)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 2,
  fillOpacity: 0.875,
  transform: "scale(1.05224)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.75s",
  values: "3.26 3.26;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.75s"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 -12 62)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 2,
  fillOpacity: 0.75,
  transform: "scale(1.33474)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.625s",
  values: "3.26 3.26;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.625s"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(135 2.645 40.326)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 2,
  fillOpacity: 0.625,
  transform: "scale(1.61724)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.5s",
  values: "3.26 3.26;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.5s"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 13 25)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 2,
  fillOpacity: 0.5,
  transform: "scale(1.89974)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.375s",
  values: "3.26 3.26;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.375s"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-135 23.356 9.674)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 2,
  fillOpacity: 0.375,
  transform: "scale(2.18224)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.25s",
  values: "3.26 3.26;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.25s"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 38 -12)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 2,
  fillOpacity: 0.25,
  transform: "scale(2.46474)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.125s",
  values: "3.26 3.26;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.125s"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-45 73.356 -64.325)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 2,
  fillOpacity: 0.125,
  transform: "scale(2.74724)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "0s",
  values: "3.26 3.26;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "0s"
})))));

export default SvgButtonLoader;